export enum ComponentType {
  INPUT = 0,
  SELECT = 1,
  BUTTON = 2,
  SCHEDULE = 3,
  TEXT = 4,
  TITLE = 5,
  HTML = 6,
  CHECKBOX = 7,
  ADDRESS = 8,
  INTITULE = 9,
  URL = 10,
  VISUAL_PUBLICATION = 11,
  ACTIVITY_PRESTATIONS = 12
}
